import {ClientHostBase} from './ClientHostBase';
import {IClientHost, IClientHostEvents, IClientHostEmitterRemoveEvent} from './IClientHost';
import {ClientHostConsumerBase} from './ClientHostConsumerBase';
import {IClientHostConsumer} from './IClientHostConsumer';
import {ClientHostFactory, registerClientHost} from './ClientHostFactory';
//import {ClientHostManager} from './ClientHostManager';
import {ClientHostDesktop} from './Common/ClientHostDesktop';
import {ClientHostDefault} from './Common/ClientHostDefault';
import * as Types from './Types';
import * as Consts from './Constants';
import {GameEvents} from './GameEvents';

export {
    Types,
    Consts,
    IClientHost, IClientHostEvents, IClientHostEmitterRemoveEvent,
    IClientHostConsumer,
    ClientHostConsumerBase,
    ClientHostBase,
    ClientHostFactory,
    registerClientHost,
    //ClientHostManager,

    ClientHostDesktop,
    ClientHostDefault,

    GameEvents
}


/** WEBPACK FOOTER **
 ** ./Engine/ClientHost/index.ts
 **/